import script from "./DlCarNatur.vue?vue&type=script&lang=ts&setup=true"
export * from "./DlCarNatur.vue?vue&type=script&lang=ts&setup=true"

import "./DlCarNatur.vue?vue&type=style&index=0&id=3938a2f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3938a2f6"]])

export default __exports__